import { API_URI } from "./config";

export default API_URI;
